import { textAlignmentMap } from "../../content/configuration";
import { flex1 } from "../../content/styles";
import DisplayTitle from "../../pages/website/DisplayTitle";
import { Page, Section, Site, WebsiteEvent } from "../../resources/modelTypes";
import { RootState } from "../../resources/reduxTypes";
import {
  selectCollection,
  SelectedCollection,
  selectSite,
} from "../../resources/selectors";
import { PageDisplayModes } from "../../website/components/EditDesign/constants";
import { PageSlugs } from "../types";
import { DisplayWebsiteContent } from "../website-display/DisplayWebsiteContent";
import { css } from "@emotion/react";
import { DesignComponent, LargeDivider } from "@minted/fancyclothes";
import { styleUtils } from "@minted/minted-components";
import React, { memo } from "react";
import { connect } from "react-redux";

const wrapperStyles = css`
  max-width: ${styleUtils.rem(975)};
  margin: 0 auto;
  padding-bottom: ${styleUtils.rem(80)};
`;

export type PageDesignComponentProps = {
  displayMode: string;
  page: Page;
};

type PageDesignComponentPropsWithRedux = {
  sectionCollection: SelectedCollection<Section>;
  eventCollection: SelectedCollection<WebsiteEvent> | null;
  isOnlineInvitation: boolean;
  site: Site;
} & PageDesignComponentProps;

class PageDesignComponent extends DesignComponent {
  props?: PageDesignComponentPropsWithRedux;
  render() {
    if (!this.props) {
      return null;
    }
    const {
      displayMode,
      eventCollection,
      isOnlineInvitation,
      page,
      sectionCollection,
      site,
    } = this.props;

    return (
      <>
        {page.slug !== PageSlugs.Home && !isOnlineInvitation && (
          <>
            {displayMode === PageDisplayModes.multiPage && <LargeDivider />}
            <DisplayTitle
              hideDivider={!page.configuration.showPageDividers}
              title={page.givenName}
            />
          </>
        )}
        <div css={wrapperStyles} id={`page-${page.slug}`}>
          <div
            css={[
              flex1,
              textAlignmentMap.get(page.configuration.textAlignment),
            ]}
          >
            <div>
              <DisplayWebsiteContent
                configuration={page.configuration}
                eventCollection={eventCollection}
                page={page}
                sectionCollection={sectionCollection}
                site={site}
              />
            </div>
          </div>
        </div>
        <LargeDivider />
      </>
    );
  }
}

const mapStateToProps = (state: RootState, props: PageDesignComponentProps) => {
  const site = selectSite(state.resources.sites);

  return {
    eventCollection:
      props.page.slug === PageSlugs.Events
        ? selectCollection(state.resources.events)
        : null,
    isOnlineInvitation: site.isOnlineInvitation,
    sectionCollection: selectCollection(state.resources.sections, {
      page: props.page.id,
    }),
    site,
  };
};

const ConnectedPageDesignComponent = connect(mapStateToProps)(
  // @ts-expect-error Force types for redux/react connection
  PageDesignComponent,
) as unknown as React.FC<PageDesignComponentProps>;

const MemoizedPageDesignComponent = memo(ConnectedPageDesignComponent);

export { MemoizedPageDesignComponent as PageDesignComponent };
